import {
  Compass, HeartHandshake, PenTool, ShoppingBag, Glasses, Smartphone, Cloud, Workflow,
  CalendarClock, GraduationCap, ScanLine, Truck, Hotel, ShoppingCart, Factory, Landmark, Radio,
  Sparkles, Boxes, Building2, Cpu, Database, Globe, Layers, LineChart, Lock, Rocket, Server, Shield, Users, Zap, BarChart3, Code2, Briefcase,
} from "lucide-react";

export const ICONS = {
  Compass, HeartHandshake, PenTool, ShoppingBag, Glasses, Smartphone, Cloud, Workflow,
  CalendarClock, GraduationCap, ScanLine, Truck, Hotel, ShoppingCart, Factory, Landmark, Radio,
  Sparkles, Boxes, Building2, Cpu, Database, Globe, Layers, LineChart, Lock, Rocket, Server, Shield, Users, Zap, BarChart3, Code2, Briefcase,
};

export const ICON_NAMES = Object.keys(ICONS);

export const Icon = ({ name, className = "h-5 w-5", ...props }) => {
  const Cmp = ICONS[name] || Sparkles;
  return <Cmp className={className} aria-hidden="true" {...props} />;
};
